import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import routes from './routes.json';
import ScrollToTop from './utils/ScrollToTop';
import './App.scss';
import MainMenu from './components/MainMenu';
import HomePage from './pages/HomePage';
import Footer from './components/Footer';
import Contact from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import AromatherapyPage from './pages/AromatherapyPage';
import MassagePage from './pages/MassagePage';
import PricesPage from './pages/PricesPage';
import WellnessPage from './pages/WellnessPage';

import Waves from './components/Waves';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <MainMenu />
      <Switch>
        <Route path={routes.CONTACT}>
          <Contact />
        </Route>
        <Route path={routes.ABOUT}>
          <AboutPage />
        </Route>
        <Route path={routes.AROMATHERAPY}>
          <AromatherapyPage />
        </Route>
        <Route path={routes.MASSAGE}>
          <MassagePage />
        </Route>
        <Route path={routes.PRICES}>
          <PricesPage />
        </Route>
        <Route path={routes.WELLNESS}>
          <WellnessPage />
        </Route>
        <Route path="/">
          <HomePage />
        </Route>
      </Switch>
      <Footer />
      <Waves />
    </Router>
  );
}

export default App;
